import React from "react";
import { Row, Col } from "antd";
import styles from "../DashBoard/Payment/Payment.module.scss";
import { formatUTCtoLocalDate } from "../../helpers/dateFormatters";

type Props = {
  refundedTransactionId: number;
  refundedAmount: number;
  refundedDate: string;
};
const RefundedServiceInfo: React.FC<Props> = ({
  refundedTransactionId,
  refundedAmount,
  refundedDate,
}) => {
  return (
    <Row className={styles.refundServiceInfo} justify="space-between">
      <Col>
        This service was refunded ${refundedAmount} on{" "}
        {formatUTCtoLocalDate(refundedDate, "MM/DD/YYYY")}.
      </Col>
      <Col>Transaction ID: {refundedTransactionId}</Col>
    </Row>
  );
};
export default RefundedServiceInfo;
